export const ENDPOINTS = {
  LOGIN: "/auth/login",
  PROFILE: "/user/profile",

   GLOBAL_SETTINGS: "/api/global-settings",
   HERO_SECTION: "/api/hero-sections",

   CDMP_OVERVIEW: "/api/cdmp-overviews",
};
